import { memo, useCallback } from 'react';
import type { Feat } from '../types';
import './FeatCard.css';

interface FeatCardProps {
  feat: Feat;
  isSelected: boolean;
  onToggle: (id: string) => void;
}

export const FeatCard = memo(function FeatCard({ feat, isSelected, onToggle }: FeatCardProps) {
  const handleToggle = useCallback(() => {
    onToggle(feat.id);
  }, [onToggle, feat.id]);

  const handleCheckboxClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <div
      className={`feat-card-mini ${isSelected ? 'selected' : ''}`}
      onClick={handleToggle}
      data-category={feat.category.toLowerCase().replace(/\s+/g, '-')}
    >
      <div className="feat-card-mini-header">
        <h3>{feat.name}</h3>
      </div>
      <div className="feat-card-mini-meta">
        <span className="feat-card-category">{feat.category}</span>
      </div>
      <input
        type="checkbox"
        checked={isSelected}
        onChange={handleToggle}
        onClick={handleCheckboxClick}
        className="feat-card-checkbox"
        aria-label={`Select ${feat.name} for print`}
      />
    </div>
  );
});
